import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { ValidText } from "../../contexts/Utils";
import {
  //GetAllPaymentDetail,
  editPayment,
  // getAccNamesCash,
  // getAccNameCusVen,
  // GetPaymentDetailByID,
  getAcc1BalFrom,
  getAccNamesExp,
  getAccNamesAssetCash,
  getAccNamesEmp,
} from "../../api";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import "../../styles/AddProduct.css";
import { Container, Col, Row } from "react-bootstrap";
import Select from "react-select";

const EditExpense = () => {
  const navigate = useNavigate();
  const { currentColor, userID, userToken } = useStateContext();
  const [acc_notes, setAccNotes] = useState("");
  const [amount_paid, setamount_paid] = useState("");
  // const [gettoacc, setgettoacc] = useState("");
  // const [getfromacc, setgetfromacc] = useState("");

  const [to_acc, setto_acc] = useState("");
  const [to_acc_Options, setto_acc_Options] = useState([]);
  const [GetAccount_To, setGetAccount_To] = useState([]);
  const [from_acc, setfrom_acc] = useState("");
  const [from_acc_Options, setfrom_acc_Options] = useState([]);
  const [GetAccount_From, setGetAccount_From] = useState([]);
  const [emp_acc, setemp_acc] = useState("");
  const [emp_acc_Options, setemp_acc_Options] = useState([]);
  const [GetAccount_Emp, setGetAccount_Emp] = useState([]);

  // const [to_acc_bal, setto_acc_bal] = useState("");
  const [from_acc_bal, setfrom_acc_bal] = useState("");
  const [emp_acc_bal, setemp_acc_bal] = useState("");
  const [store_id, setStore_id] = useState(0);
  const [acc_from_id, setacc_from_id] = useState(null);
  const [acc_to_id, setacc_to_id] = useState(null);
  const [acc_emp_id, setacc_emp_id] = useState(null);
  const [acc_from_id1, setacc_from_id1] = useState(null);
  const [acc_to_id1, setacc_to_id1] = useState(null);
  const [acc_emp_id1, setacc_emp_id1] = useState(null);
  const [ValError, setValError] = useState([]);
  const [oDatetime, setODatetime] = useState("");
  const [loadBtn, setLoadBtn] = useState(false);
  //const [role, setRole] = useState("");
  let param = useParams();
  const [rid] = useState(param.r_id);

  const handleChangeAccNote = (e) => {
    setAccNotes(e.target.value);
  };

  const handleChangeAmountPaid = (e) => {
    setamount_paid(e.target.value);
  };

  const handleChangeAcc_To = async (selectedOption) => {
    TimeoutUtility.resetTimeout();
    // setto_acc_bal("");
    if (selectedOption === null) {
      setto_acc("");
      setacc_to_id("");
    } else {
      if (selectedOption.label !== "") {
        const updatedErrors = [...ValError];
        updatedErrors[0] = "";
        setValError(updatedErrors);
      }
      if (selectedOption && selectedOption.value) {
        if (selectedOption.value) {
          // try {
          //   const resp = await getAcc1BalFrom(selectedOption.value, userID, userToken);
          // setto_acc_bal(selectedOption.bal);
          // } catch (err) {
          //   console.log(err.message);
          // }
          setto_acc(selectedOption);
          setacc_to_id(selectedOption.value);
        }
      }
    }
  };

  const ValidText1 = (txt, ii) => {
    const updatedErrors = [...ValError];
    if (txt.trim().length === 0) {
      updatedErrors[ii] = "";
      setValError(updatedErrors);
      return false;
    }
    if (ValidText(txt)) {
      updatedErrors[ii] = "";
      setValError(updatedErrors);
      return true;
    }
    updatedErrors[ii] = "Invalid field!";
    setValError(updatedErrors);
    return false;
  };

  const handleChangeAcc_From = async (selectedOption) => {
    TimeoutUtility.resetTimeout();
    setfrom_acc_bal("");
    if (selectedOption === null) {
      setfrom_acc("");
      setacc_from_id("");
    } else {
      if (selectedOption.label !== "") {
        const updatedErrors = [...ValError];
        updatedErrors[1] = "";
        setValError(updatedErrors);
      }
      if (selectedOption && selectedOption.value) {
        if (selectedOption.value) {
          setfrom_acc_bal(selectedOption.bal);
          setfrom_acc(selectedOption);
          setacc_from_id(selectedOption.value);
        }
      }
    }
  };

  const handleChangeAcc_Emp = async (selectedOption) => {
    TimeoutUtility.resetTimeout();
    setemp_acc_bal("");
    if (selectedOption === null) {
      setemp_acc("");
      setacc_emp_id("");
    } else {
      if (selectedOption.label !== "") {
        const updatedErrors = [...ValError];
        updatedErrors[1] = "";
        setValError(updatedErrors);
      }
      if (selectedOption && selectedOption.value) {
        if (selectedOption.value) {
          setemp_acc_bal(selectedOption.bal);
          setemp_acc(selectedOption);
          setacc_emp_id(selectedOption.value);
        }
      }
    }
  };

  const formatCurrency = (number) => {
    return number.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 2,
    });
  };

  const handleBackClick = async (event) => {
    TimeoutUtility.resetTimeout();
    event.preventDefault();
    try {
      // console.log("Back");
      navigate("/Expense");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleSubmit = async (e) => {
    TimeoutUtility.resetTimeout();
    e.preventDefault();
    setLoadBtn(true);
    var resp = 0;
    try {
      setValError([]);
      const updatedErrors = [...ValError];

      // if (role === "B3" || role === "S3") {
      if (to_acc === "") {
        updatedErrors[0] = "Please select receive in a/c.";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[0] = "";

      if (from_acc === "") {
        updatedErrors[1] = "Please select receive from a/c.";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[1] = "";
      // }

      if (amount_paid === "") {
        updatedErrors[2] = "Please enter Amount Paid!";
        setValError(updatedErrors);
        return;
      }
      if (amount_paid < 1) {
        updatedErrors[2] = "Amount paid must be greater than 0!";
        setValError(updatedErrors);
        return;
      }
      updatedErrors[2] = "";

      if (acc_notes) {
        if (ValidText1(acc_notes, 3) === false) {
          return;
        }
      }
      updatedErrors[3] = "";

      // console.log(acc_from_id1, acc_to_id1);
      // if (role === "B3" || role === "S3") {
      var aa = null;
      var b = null;
      var cc = null;
      if (acc_from_id === null) {
        aa = acc_from_id1;
      } else {
        aa = acc_from_id;
      }
      if (acc_to_id === null) {
        b = acc_to_id1;
      } else {
        b = acc_to_id;
      }
      if (acc_emp_id === null) {
        cc = acc_emp_id1;
      } else {
        cc = acc_emp_id;
      }
      // console.log(cc);
      const response = await editPayment(
        param.r_id,
        aa,
        to_acc?.label?.slice(0, 4) === "3501" ? cc : b,
        11,
        amount_paid,
        acc_notes,
        false,
        null,
        userID,
        userToken
      );
      // console.log(response, "Response");
      resp = response.status;
      if (resp === 200) {
        alert("Expense update successfully.");
      } else {
        alert("Expense failed to update.");
      }
    } catch (err) {
    } finally {
      setLoadBtn(false);
      if (resp === 200) {
        navigate("/Expense");
      }
    }
  };

  useEffect(() => {
    const fetchAcc_ToOptions = async () => {
      const fetchedProductOptions = GetAccount_To.map((item) => ({
        label: item.name,
        value: item.account_id,
        bal: item.end_balance,
      }));
      setto_acc_Options(fetchedProductOptions);
    };
    fetchAcc_ToOptions();
  }, [GetAccount_To]);

  useEffect(() => {
    const fetchAcc_ToOptions = async () => {
      const fetchedProductOptions = GetAccount_From.map((item) => ({
        label: item.name,
        value: item.account_id,
        bal: item.end_balance,
      }));
      setfrom_acc_Options(fetchedProductOptions);
    };
    fetchAcc_ToOptions();
  }, [GetAccount_From]);

  useEffect(() => {
    const fetchAcc_ToOptions = async () => {
      const fetchedProductOptions = GetAccount_Emp.map((item) => ({
        label: item.name,
        value: item.account_id,
        bal: item.end_balance,
      }));
      setemp_acc_Options(fetchedProductOptions);
    };
    fetchAcc_ToOptions();
  }, [GetAccount_Emp]);

  useEffect(() => {
    async function fetchData() {
      if (store_id !== 0 && rid && userID && userToken) {
        var to_det = null;
        var from_det = null;
        var emp_det = null;

        await getAccNamesExp(store_id, userID, userToken)
          .then((resp) => {
            to_det = resp.data;
          })
          .catch((err) => {
            console.log(err.message);
          });

        await getAccNamesAssetCash(store_id, userID, userToken)
          .then((resp1) => {
            from_det = resp1.data;
          })
          .catch((err) => {
            console.log(err.message);
          });

        await getAccNamesEmp(store_id, userID, userToken)
          .then((resp2) => {
            emp_det = resp2.data;
          })
          .catch((err) => {
            console.log(err.message);
          });

        try {
          const resp1 = await getAcc1BalFrom(rid, userID, userToken);
          //console.log(resp1.data);
          // setgetfromacc(resp1.data[0].from);
          setAccNotes(resp1.data[0].note);
          setamount_paid(resp1.data[0].amount_paid);
          var d1 = new Date(resp1.data[0].datetime);
          d1.setMinutes(d1.getMinutes() - d1.getTimezoneOffset());
          setODatetime(d1.toISOString().slice(0, 19));

          var d2 = d1.toISOString().slice(0, 19);
          if (to_det.length > 0) {
            const filteredAccTo = to_det.filter(
              (item) => new Date(item.open_datetime) <= new Date(d2)
            );
            setGetAccount_To(filteredAccTo);
          }
          if (from_det.length > 0) {
            const filteredAccFrom = from_det.filter(
              (item) => new Date(item.open_datetime) <= new Date(d2)
            );
            setGetAccount_From(filteredAccFrom);
          }
          if (emp_det.length > 0) {
            const filteredAccEmp = emp_det.filter(
              (item) => new Date(item.open_datetime) <= new Date(d2)
            );
            setGetAccount_Emp(filteredAccEmp);
          }

          //console.log("fomdet", from_det);
          //console.log("resp1data", resp1.data[0].from);
          const fromAccOption = from_det.find(
            (option) => option.account_id === resp1.data[0].acc_from_id
          );
          //console.log("frmaccopt", fromAccOption);

          const fromAccOption1 = {
            label: fromAccOption.name,
            value: fromAccOption.account_id,
            bal: fromAccOption.end_balance,
            o_datetime: fromAccOption.open_datetime,
          };
          setfrom_acc(fromAccOption1);
          setfrom_acc_bal(fromAccOption1.bal);

          var accOption = null;
          if (
            resp1.data[0].code_to > 21019999 &&
            resp1.data[0].code_to < 21030000
          ) {
            accOption = to_det.find(
              (option) => option.name?.slice(0, 4) === "3501"
            );
            const toAccOption1 = {
              label: accOption.name,
              value: accOption.account_id,
              bal: accOption.end_balance,
              o_datetime: accOption.open_datetime,
            };
            setto_acc(toAccOption1);

            accOption = emp_det.find(
              (option) => option.account_id === resp1.data[0].acc_to_id
            );
            const empAccOption1 = {
              label: accOption.name,
              value: accOption.account_id,
              bal: accOption.end_balance,
              o_datetime: accOption.open_datetime,
            };
            setemp_acc(empAccOption1);
            setemp_acc_bal(empAccOption1.bal);
          } else {
            accOption = to_det.find(
              (option) => option.account_id === resp1.data[0].acc_to_id
            );
            const toAccOption1 = {
              label: accOption.name,
              value: accOption.account_id,
              bal: accOption.end_balance,
              o_datetime: accOption.open_datetime,
            };
            setto_acc(toAccOption1);
            // setto_acc_bal(toAccOption1.bal);
          }

          setacc_to_id1(accOption.account_id);
          setacc_emp_id1(accOption.account_id);
          setacc_from_id1(fromAccOption.account_id);
        } catch (err) {
          console.log(err.message);
        }
      }
    }
    fetchData();
  }, [store_id, rid, userID, userToken]);

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    async function fetchData() {
      if (rid && userID && userToken) {
        const resp1 = await getAcc1BalFrom(rid, userID, userToken);
        setStore_id(resp1.data[0].store_id);
      }
    }
    fetchData();
  }, [rid, userID, userToken]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 bg-white rounded-3xl">
      <Header title="EDIT EXPENSE" />
      <form>
        <Container
          className="g-0 justify-center"
          fluid="true"
          style={{ paddingLeft: "8%", paddingRight: "8%", paddingTop: "18px" }}
        >
          <Row
            xs={1}
            sm={1}
            className="justify-content-center"
            style={{
              padding: "0",
            }}
          >
            <Col md={6} className="container-col">
              {/* {(role === "B3" || role === "S3") && ( */}
              <>
                <div className="col-lg-12">
                  <div className="form-group">
                    <label className="label">DateTime:</label>
                    <div className="flex mb-2">
                      <input
                        disabled
                        className="input"
                        id="o_date"
                        type="datetime-local"
                        value={oDatetime}
                      />
                    </div>
                  </div>
                </div>
                <br />
                <div className="col-lg-12">
                  <div className="form-group">
                    <label className="label" htmlFor="ProductSelect">
                      Expense Type:
                    </label>
                    <div className="flex mb-2">
                      <Select
                        className="myreact-select container-select"
                        value={to_acc}
                        onChange={handleChangeAcc_To}
                        options={to_acc_Options}
                        isSearchable
                        placeholder="Select Receive In Account"
                        isClearable
                      />
                      <span className="label-imp-select">*</span>
                    </div>
                    {ValError[0] && (
                      <p className="label-error-select">{ValError[0]}</p>
                    )}
                  </div>
                </div>
                <br />
                {to_acc?.label?.slice(0, 4) === "3501" && (
                  <>
                    <div className="col-lg-12">
                      <div className="form-group">
                        <label className="label" htmlFor="ProductSelect">
                          Employee Account:
                        </label>
                        <div className="flex mb-2">
                          <Select
                            className="myreact-select container-select"
                            value={emp_acc}
                            onChange={handleChangeAcc_Emp}
                            options={emp_acc_Options}
                            isSearchable
                            placeholder="Select Employee Account"
                            isClearable
                          />
                          <span className="label-imp-select">*</span>
                        </div>
                        {ValError[4] && (
                          <p className="label-error-select">{ValError[4]}</p>
                        )}
                      </div>
                    </div>
                    <br />
                  </>
                )}

                <div className="col-lg-12">
                  <div className="form-group">
                    <label className="label" htmlFor="ProductSelect">
                      Paid From:
                    </label>
                    <div className="flex mb-2">
                      <Select
                        className="myreact-select container-select"
                        value={from_acc}
                        onChange={handleChangeAcc_From}
                        options={from_acc_Options}
                        isSearchable
                        placeholder="Select Receive From Account"
                        isClearable
                      />
                      <span className="label-imp-select">*</span>
                    </div>
                    {ValError[1] && (
                      <p className="label-error-select">{ValError[1]}</p>
                    )}
                    {/* <div>Bal: {formatCurrency(from_acc_bal)}</div> */}
                  </div>
                </div>
                <br />
              </>
              {/* )} */}
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">Amount:</label>
                  <input
                    type="number"
                    step="1.00"
                    min="0"
                    //defaultValue={0.0}
                    value={amount_paid}
                    onChange={handleChangeAmountPaid}
                    name="amount_paid"
                    placeholder="Enter Account"
                    className="input"
                  />
                  <span className="label-imp">*</span>
                  {ValError[2] && <p className="label-error">{ValError[2]}</p>}
                </div>
              </div>
              <br />
              <div className="col-lg-12">
                <div className="form-group">
                  <label className="label">Note: </label>
                  <textarea
                    placeholder="Note"
                    id="noteTextarea"
                    value={acc_notes}
                    onChange={handleChangeAccNote}
                    className="textarea"
                    onBlur={(e) => ValidText1(e.target.value, 3)}
                  />
                  {ValError[3] && (
                    <p className="label-error-dt">{ValError[3]}</p>
                  )}
                </div>
              </div>
              <br />
              <br />
            </Col>
            {/* {(role === "B3" || role === "S3") && ( */}
            <Col md={2} className="container-col">
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
              {to_acc?.label?.slice(0, 4) === "3501" && (
                <>
                  <div className="col-lg-12">
                    <div className="form-group mt-8">
                      <label className="label">
                        Bal: {formatCurrency(emp_acc_bal)}
                      </label>
                    </div>
                  </div>
                  <br />
                </>
              )}
              <div className="col-lg-12">
                <div className="form-group mt-8">
                  <label className="label">
                    Bal: {formatCurrency(from_acc_bal)}
                  </label>
                </div>
              </div>
              <br />
            </Col>
            {/* )} */}
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center">
        <Button
          margin="10px"
          padding="20px"
          color="white"
          className="custom-button ml-2"
          bgColor={currentColor}
          text="Update"
          borderRadius="10px"
          onClick={handleSubmit}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          color="white"
          className="custom-button ml-2"
          bgColor={currentColor}
          text="Back"
          borderRadius="10px"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default EditExpense;
